/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.makeGiftCardPurchase.internal

import features.makeGiftCardPurchase.models.GiftCardPayPalPaymentResponseModel
import features.makeGiftCardPurchase.models.GiftCardPurchaseRequest
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.makeGiftCardPurchase.internal.GiftCardPurchaseUseCase.Params

internal class GiftCardPurchaseUseCase : AsyncUseCase<GiftCardPayPalPaymentResponseModel, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val purchaseGiftCardRequest: GiftCardPurchaseRequest
    )

    private val giftCardPurchaseService: GiftCardPurchaseService = GiftCardPurchaseServiceImpl()

    override suspend fun run(params: Params): Result<GiftCardPayPalPaymentResponseModel> {
        return giftCardPurchaseService.purchaseGiftCard(
            overrideHeaders = params.overrideHeaders,
            purchaseGiftCardRequest = params.purchaseGiftCardRequest
        )
    }
}
